export default "__VITE_ASSET__97e02721__"